export default "__VITE_ASSET__Yv4JgUGC__"